module.exports = __webpack_public_path__ + "img/key_history.d5541a11.svg";